import { cva } from "cva";

export const navbarNavStyles = cva({
  base: "relative",
});

export const navbarStyles = cva({
  base: "flex items-center justify-center list-none",
});
